import { useRef, useState } from 'react';
import cx from 'classnames';

const SpeakerIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8463 11.975C18.8463 10.598 18.478 9.34194 17.7413 8.20677C17.0048 7.07144 16.0167 6.22369 14.7771 5.66352C14.5847 5.57252 14.4431 5.4366 14.3521 5.25577C14.2611 5.0751 14.2508 4.89177 14.3213 4.70577C14.402 4.50327 14.5442 4.36294 14.7481 4.28477C14.9519 4.20644 15.1583 4.21285 15.3673 4.30402C16.875 4.98852 18.0817 6.0186 18.9876 7.39427C19.8932 8.76994 20.3461 10.2969 20.3461 11.975C20.3461 13.6532 19.8932 15.1801 18.9876 16.5558C18.0817 17.9314 16.875 18.9615 15.3673 19.646C15.1583 19.7372 14.9519 19.7436 14.7481 19.6653C14.5442 19.5871 14.402 19.4468 14.3213 19.2443C14.2508 19.0583 14.2611 18.8749 14.3521 18.6943C14.4431 18.5134 14.5847 18.3775 14.7771 18.2865C16.0167 17.7264 17.0048 16.8786 17.7413 15.7433C18.478 14.6081 18.8463 13.352 18.8463 11.975ZM7.36555 14.5H4.5578C4.30014 14.5 4.08505 14.4138 3.91255 14.2413C3.74022 14.0689 3.65405 13.8539 3.65405 13.596V10.404C3.65405 10.1462 3.74022 9.9311 3.91255 9.75877C4.08505 9.58627 4.30014 9.50002 4.5578 9.50002H7.36555L10.3578 6.50777C10.5975 6.2681 10.8734 6.21327 11.1856 6.34327C11.4977 6.47344 11.6538 6.70902 11.6538 7.05002V16.95C11.6538 17.291 11.4977 17.5266 11.1856 17.6568C10.8734 17.7868 10.5975 17.7319 10.3578 17.4923L7.36555 14.5ZM16.1538 12C16.1538 12.623 16.0243 13.2134 15.7653 13.7713C15.5065 14.3289 15.1571 14.7981 14.7173 15.1788C14.5763 15.2724 14.4279 15.2814 14.2721 15.2058C14.1164 15.1301 14.0386 15.0051 14.0386 14.8308V9.11927C14.0386 8.94494 14.1164 8.81994 14.2721 8.74427C14.4279 8.6686 14.5763 8.6776 14.7173 8.77127C15.1571 9.16227 15.5065 9.64235 15.7653 10.2115C16.0243 10.7809 16.1538 11.377 16.1538 12Z"
      fill="white"
    />
  </svg>
);

const SpeakerMutedIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4578 19.123C16.2936 19.2268 16.1263 19.3256 15.9558 19.4192C15.7853 19.5127 15.6096 19.598 15.4288 19.675C15.2429 19.7597 15.0497 19.7597 14.849 19.675C14.6484 19.5903 14.5109 19.4499 14.4365 19.2537C14.3622 19.0679 14.3731 18.883 14.4693 18.699C14.5654 18.515 14.7064 18.3807 14.8923 18.2962C15.0283 18.2397 15.1543 18.1775 15.2703 18.1095C15.3863 18.0417 15.5007 17.9647 15.6135 17.8787L11.7885 14.4537V16.95C11.7885 17.291 11.6324 17.5266 11.3203 17.6567C11.0081 17.7867 10.7321 17.7319 10.4923 17.4922L7.50003 14.5H4.69228C4.43461 14.5 4.21961 14.4137 4.04728 14.2412C3.87478 14.0689 3.78853 13.8538 3.78853 13.596V10.404C3.78853 10.1462 3.87478 9.93107 4.04728 9.75874C4.21961 9.58624 4.43461 9.49999 4.69228 9.49999H6.83478L2.52303 5.18849C2.38469 5.04999 2.31386 4.87599 2.31053 4.66649C2.30736 4.45682 2.37819 4.27957 2.52303 4.13474C2.66803 3.98974 2.84369 3.91724 3.05003 3.91724C3.25653 3.91724 3.43219 3.98974 3.57703 4.13474L20 20.5577C20.1385 20.6962 20.2094 20.8702 20.2125 21.0797C20.2157 21.2894 20.1449 21.4667 20 21.6115C19.8552 21.7563 19.6795 21.8287 19.473 21.8287C19.2667 21.8287 19.0911 21.7563 18.9463 21.6115L16.4578 19.123ZM18.9808 11.975C18.9808 10.6045 18.6125 9.34999 17.876 8.21149C17.1395 7.07299 16.1514 6.22365 14.9115 5.66349C14.7192 5.57249 14.5775 5.43657 14.4865 5.25574C14.3955 5.07507 14.3853 4.89174 14.4558 4.70574C14.5366 4.50324 14.6789 4.3629 14.8828 4.28474C15.0866 4.2064 15.293 4.21282 15.502 4.30399C17.0097 4.98849 18.2164 6.01599 19.122 7.38649C20.0279 8.75699 20.4808 10.2865 20.4808 11.975C20.4808 12.6148 20.4067 13.2376 20.2585 13.8432C20.1105 14.4491 19.8968 15.0244 19.6173 15.5692C19.5031 15.8397 19.3438 16.0064 19.1393 16.0692C18.9349 16.1321 18.7449 16.1314 18.5693 16.0672C18.3936 16.0032 18.2574 15.8885 18.1605 15.723C18.0637 15.5577 18.0659 15.3718 18.1673 15.1655C18.4404 14.6745 18.6443 14.1664 18.7788 13.6412C18.9134 13.1162 18.9808 12.5608 18.9808 11.975ZM14.8615 8.77124C15.3282 9.12757 15.6827 9.6109 15.925 10.2212C16.1674 10.8314 16.2885 11.4243 16.2885 12C16.2885 12.1475 16.2805 12.2933 16.2645 12.4375C16.2484 12.5817 16.2192 12.7243 16.177 12.8655C16.1309 13.0565 16.0158 13.1773 15.8318 13.228C15.6478 13.2785 15.482 13.2301 15.3345 13.0827L14.4443 12.1922C14.3506 12.0987 14.282 11.9975 14.2385 11.8885C14.1949 11.7795 14.173 11.6647 14.173 11.5442V9.12874C14.173 8.9544 14.2525 8.82782 14.4115 8.74899C14.5705 8.67015 14.7205 8.67757 14.8615 8.77124ZM9.94228 7.69049C9.84878 7.59682 9.80361 7.48974 9.80678 7.36924C9.80994 7.24874 9.85836 7.14174 9.95203 7.04824L10.4923 6.50774C10.7321 6.26807 11.0081 6.21324 11.3203 6.34324C11.6324 6.4734 11.7885 6.70899 11.7885 7.04999V8.44224C11.7885 8.65007 11.6965 8.79399 11.5125 8.87399C11.3285 8.95415 11.1628 8.91732 11.0153 8.76349L9.94228 7.69049Z"
      fill="white"
    />
  </svg>
);

interface VideoControlProps {
  currentTime?: number;
  duration?: number;
  muted: boolean;
  onChangeTime: (newTime: number) => void;
  onChangeVolume: (newVolume: number) => void;
  onMuteUnmute: () => void;
  visible: boolean;
  volume?: number;
}

const VideoControls = ({
  currentTime = 0,
  duration = 0,
  muted = false,
  onChangeTime,
  onChangeVolume,
  onMuteUnmute,
  visible,
  volume = 0,
}: VideoControlProps) => {
  const progressRef = useRef<HTMLDivElement>(null);
  const volumeRef = useRef<HTMLDivElement>(null);
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);

  const handleProgressClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (progressRef.current) {
      const gotoTime =
        (event.nativeEvent.offsetX / progressRef.current.offsetWidth) *
        duration;
      onChangeTime(gotoTime);
    }
  };

  const handleVolumeClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (volumeRef.current) {
      const newVolume =
        (volumeRef.current.offsetHeight - event.nativeEvent.offsetY) /
        volumeRef.current.offsetHeight;
      onChangeVolume(newVolume);
    }
  };

  return (
    <div className="flex gap-2 w-full items-end h-16 pointer-events-none">
      <div
        className="flex flex-col h-full gap-1 items-center bg-transparent pointer-events-auto"
        onMouseLeave={() => setShowVolumeSlider(false)}
      >
        <div
          className={cx(
            'flex flex-col w-2 h-full bg-GSbase/white/30 rounded',
            'transform transition duration-500',
            {
              'opacity-0': !showVolumeSlider,
              'opacity-0 md:opacity-100 cursor-pointer': showVolumeSlider,
            },
          )}
          onClick={handleVolumeClick}
          ref={volumeRef}
        >
          <div
            style={{ flexBasis: `${100 - volume * 100}%` }}
            className="pointer-events-none"
          />
          <div
            style={{ flexBasis: muted ? 0 : `${volume * 100}%` }}
            className="bg-GSbase/white h-full rounded pointer-events-none"
          />
        </div>
        <div
          className={cx({ 'pointer-events-auto cursor-pointer': visible })}
          onMouseOver={visible ? () => setShowVolumeSlider(true) : undefined}
          onFocus={visible ? () => setShowVolumeSlider(true) : undefined}
          onClick={visible ? () => onMuteUnmute() : undefined}
        >
          {muted ? <SpeakerMutedIcon /> : <SpeakerIcon />}
        </div>
      </div>
      <div
        className={cx(
          'flex w-full bg-GSbase/white/30 h-2 rounded pointer-events-auto my-2 mr-1',
          {
            'cursor-pointer': visible,
          },
        )}
        onClick={handleProgressClick}
        ref={progressRef}
      >
        {duration && duration > 0 && (
          <div
            className="bg-GSbase/white opacity-100 h-full rounded pointer-events-none"
            style={{
              flexBasis: `${(currentTime / duration) * 100}%`,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default VideoControls;
